module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "public-app"
  }, [(_vm.isMobile) ? _c('app', {
    attrs: {
      "calId": _vm.calId,
      "viewState": _vm.viewState,
      "schoolName": _vm.schoolName,
      "calName": _vm.calName,
      "i18n": _vm.i18n
    },
    on: {
      "setLocale": _vm.setLocale,
      "eventClick": _vm.setActiveEvent
    }
  }) : [(_vm.view === 'desktop') ? _c('desktop', {
    attrs: {
      "calId": _vm.calId,
      "schoolName": _vm.schoolName,
      "viewState": _vm.viewState,
      "i18n": _vm.i18n
    },
    on: {
      "eventClick": _vm.setActiveEvent,
      "setLocale": _vm.setLocale
    }
  }) : _vm._e(), _vm._v(" "), (_vm.view === 'smartscreen') ? _c('desktopVue', {
    attrs: {
      "calendarId": _vm.calId,
      "calendar": _vm.calendar
    }
  }) : _vm._e()], _vm._v(" "), _c('transition', {
    attrs: {
      "name": "aniZoomIn"
    }
  }, [(_vm.activeEvent !== null) ? _c('show-event', {
    attrs: {
      "locale": _vm.locale,
      "event": _vm.activeEvent,
      "i18n": _vm.i18n
    },
    on: {
      "close": function($event) {
        _vm.activeEvent = null
      }
    }
  }) : _vm._e()], 1)], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-694147c9!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/public/PublicContainer.vue
// module id = 1649
// module chunks = 1